import { combineReducers } from "@reduxjs/toolkit";
import { registerApi } from "./registerapi";
import cartSlice from "./cart";
import checkoutSlice from "./checkout";

export const rootReducer = combineReducers({
    cart: cartSlice,
    checkout: checkoutSlice,
    [registerApi.reducerPath]: registerApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
